var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKcLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#050050"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 12.5C31.4561 12.5 37.5 17.6502 37.5 24.0018C37.5 30.3534 31.4561 35.5 24 35.5C16.5475 35.5 10.5 30.3498 10.5 23.9982C10.5 17.6466 16.5439 12.5 24 12.5ZM26.5909 15.0843H21.5464V22.3993C20.9713 21.067 19.6938 19.8916 18.3944 19.0959H12.9167C14.6929 20.4246 17.4954 22.5052 17.4954 24.1661C17.4954 24.991 16.4945 25.1588 15.9267 25.1588H12.4727V29.1376H17.8849C19.0969 29.1376 20.8402 28.6959 21.5464 26.8197V32.1526H26.5909V26.8197C27.297 28.6959 29.0404 29.1376 30.2524 29.1376H35.6646V25.1588H32.2105C31.6391 25.1588 30.6418 24.9946 30.6418 24.1661C30.6418 22.5052 33.448 20.4246 35.2205 19.0959H29.7428C28.4435 19.8916 27.166 21.0634 26.5909 22.3993V15.0843Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKcLogo);
export default __webpack_public_path__ + "static/media/KCLogo.36b34ea0a4e3486975632ecf8092a799.svg";
export { ForwardRef as ReactComponent };